var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductionSupport1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2873.87 2890.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#91b3fa;}.cls-4{fill:#7d97f4;}.cls-5{fill:#2b69b3;}.cls-41,.cls-42,.cls-6{fill:#fff;}.cls-7{clip-path:url(#clip-path);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{clip-path:url(#clip-path-2);}.cls-14{fill:#18174a;}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{clip-path:url(#clip-path-3);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{clip-path:url(#clip-path-4);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{opacity:0.7;}.cls-42{opacity:0.78;}.cls-43{fill:url(#linear-gradient-31);}.cls-44{fill:url(#linear-gradient-32);}.cls-45{fill:url(#linear-gradient-33);}.cls-46{fill:url(#linear-gradient-34);}.cls-47{fill:url(#linear-gradient-35);}.cls-48{fill:url(#linear-gradient-36);}.cls-49{fill:url(#linear-gradient-37);}.cls-50{fill:url(#linear-gradient-38);}.cls-51{fill:url(#linear-gradient-39);}.cls-52{fill:url(#linear-gradient-40);}.cls-53{fill:url(#linear-gradient-41);}.cls-54{fill:url(#linear-gradient-42);}.cls-55{fill:url(#linear-gradient-43);}.cls-56{fill:url(#linear-gradient-44);}.cls-57{fill:url(#linear-gradient-45);}.cls-58{fill:url(#linear-gradient-46);}.cls-59{fill:url(#linear-gradient-47);}.cls-60{fill:url(#linear-gradient-48);}.cls-61{fill:url(#linear-gradient-49);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3091.11,
    y1: 3345.1,
    x2: 1113.24,
    y2: 1239.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1904.82,
    cy: 575.84,
    r: 199.87,
    transform: "translate(150.73 1515.57) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1900.15,
    y1: 506.58,
    x2: 1912.43,
    y2: 696.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1901.13,
    y1: 605.79,
    x2: 1916.93,
    y2: 405.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1957.02,
    y1: 610.21,
    x2: 1972.82,
    y2: 410.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1843.96,
    y1: 601.27,
    x2: 1859.75,
    y2: 401.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1902.36,
    y1: 413.94,
    x2: 1928.01,
    y2: 612.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2340.58,
    cy: 464.65,
    r: 183.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2287.96,
    y1: 169.55,
    x2: 2308.23,
    y2: 302.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2294.52,
    y1: 423.37,
    x2: 2347.17,
    y2: 255.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2372.27,
    y1: 447.72,
    x2: 2424.92,
    y2: 279.61,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2382.09,
    y1: 155.19,
    x2: 2402.36,
    y2: 288.07,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2181.44,
    y1: 185.8,
    x2: 2201.71,
    y2: 318.68,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2336.98,
    y1: 597.71,
    x2: 2361.25,
    y2: 435.27,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2325.22,
    y1: 632.83,
    x2: 2336.93,
    y2: 554.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2221.36,
    y1: 179.71,
    x2: 2241.63,
    y2: 312.59,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2339.55,
    y1: 161.68,
    x2: 2359.82,
    y2: 294.56,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2330.15,
    y1: 434.53,
    x2: 2382.8,
    y2: 266.42,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1995.84,
    cy: 1065.41,
    r: 206.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -4267.45,
    y1: 1733.87,
    x2: -4299.08,
    y2: 1961.37,
    gradientTransform: "matrix(-0.97, 0.24, 0.24, 0.97, -2601.28, 314.46)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1980.8,
    y1: 1127.56,
    x2: 2039.21,
    y2: 802.7,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3461.02,
    y1: 982.08,
    x2: -3492.65,
    y2: 1209.58,
    gradientTransform: "matrix(-1, 0, 0, 1, -1482.22, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2001.56,
    y1: 752.1,
    x2: 2001.56,
    y2: 970.55,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2124.34,
    y1: 752.09,
    x2: 2124.34,
    y2: 970.56,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1889.46,
    y1: 752.09,
    x2: 1889.46,
    y2: 970.55,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2472.4,
    cy: 895.64,
    r: 186.17,
    transform: "translate(90.84 2010.58) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 3053.16,
    y1: -139.74,
    x2: 2860.61,
    y2: 240.29,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2509.09,
    y1: 754.89,
    x2: 2442.4,
    y2: 1062.68,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2469.02,
    y1: 854.2,
    x2: 2511.76,
    y2: 649.9,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2518.55,
    y1: 864.57,
    x2: 2561.29,
    y2: 660.26,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2426.27,
    y1: 845.26,
    x2: 2469.01,
    y2: 640.95,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 2474.24,
    y1: 756.97,
    x2: 2494.17,
    y2: 911.18,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1596.1,
    y1: -877.99,
    x2: 1403.55,
    y2: -497.95,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1596.1,
    y1: -877.99,
    x2: 1403.55,
    y2: -497.95,
    gradientTransform: "translate(917.63 -137.57) rotate(45)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1582.43,
    y1: -884.91,
    x2: 1389.88,
    y2: -504.88,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1615.56,
    y1: -868.12,
    x2: 1423.01,
    y2: -488.09,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1709.7,
    y1: -820.43,
    x2: 1517.15,
    y2: -440.4,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1709.7,
    y1: -820.43,
    x2: 1517.15,
    y2: -440.4,
    gradientTransform: "translate(837.6 -380.53) rotate(45)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1696.03,
    y1: -827.36,
    x2: 1503.48,
    y2: -447.32,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1729.16,
    y1: -810.57,
    x2: 1536.61,
    y2: -430.53,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1881.73,
    y1: -733.17,
    x2: 1689.18,
    y2: -353.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1881.77,
    y1: -733.25,
    x2: 1689.22,
    y2: -353.21,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1868.1,
    y1: -740.17,
    x2: 1675.55,
    y2: -360.14,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1901.23,
    y1: -723.39,
    x2: 1708.68,
    y2: -343.35,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -3549.43,
    y1: 682.85,
    x2: -3336.93,
    y2: 1166.34,
    gradientTransform: "matrix(-0.98, -0.21, -0.21, 0.98, -1826.01, -210.53)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -3232.35,
    y1: 3216.56,
    x2: -3091.98,
    y2: 1576.04,
    gradientTransform: "matrix(-1, 0, 0, 1, -2011.05, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -2949.99,
    y1: 3240.97,
    x2: -2809.59,
    y2: 1600.02,
    gradientTransform: "matrix(-1, 0, 0, 1, -2011.05, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -3247.74,
    y1: 1599.5,
    x2: -3221.37,
    y2: 1406.6,
    gradientTransform: "matrix(-1, 0, 0, 1, -2011.05, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -3369.35,
    y1: 918.25,
    x2: -3139.29,
    y2: 508.81,
    gradientTransform: "matrix(-0.98, -0.19, -0.19, 0.98, -1842.94, -188.18)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -3320.38,
    y1: 945.77,
    x2: -3090.31,
    y2: 536.33,
    gradientTransform: "matrix(-0.98, -0.19, -0.19, 0.98, -1842.94, -188.18)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -3591.43,
    y1: 701.31,
    x2: -3378.92,
    y2: 1184.8,
    gradientTransform: "matrix(-0.98, -0.21, -0.21, 0.98, -1826.01, -210.53)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1622.72,
    y1: 1075.38,
    x2: 1679.94,
    y2: 1075.38,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 752.28,
    y1: 1848.99,
    x2: 1303.73,
    y2: 1618.3,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2497.25,2500.39c-73,75.26-138.34,119.5-188.36,152.9C1821.05,2979,1263.41,2885.14,1091,2853.05c-278.17-51.77-513-88.3-714.72-270.56C-82.14,2168.32-59.84,1304.35,290.45,769.15c41.53-63.46,391.29-581.91,950.14-655,13.67-1.79,23.87-2.81,32.8-3.76,86.46-9.15,622.19-57.46,1059,308.52,62.53,52.39,163.16,146.89,256.48,291C2930.11,1236.93,2931.19,2053.1,2497.25,2500.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M917.08,1395.92c67.87-131.83,194.09-224.77,340.71-241.37l10-634.74a9.67,9.67,0,0,0-9.74-9.83c-413.53,4.48-778.43,261.86-948.72,643.09a10.61,10.61,0,0,0,5.94,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1734.23,1700a18.94,18.94,0,0,0-18.62,13.28c-7.1,22.7-20.08,66.24-22.21,71.75a582.4,582.4,0,0,1-36.63,77.88c-26.31,46.32-60,88.76-101.45,122.37-105.19,85.18-256.4,101-382.53,58.85-3.59-1.2-7.16-2.49-10.71-3.82a14.09,14.09,0,0,0-17.31,6.42l-318,580c154.43,77.44,299.75,97.69,482.08,86,529.73-33.95,945.69-464.06,991.86-997.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1734.23,1700c-34.48,211.66-190.9,377-403.45,384.25-59.8,2-131.15-11.86-183.6-33.1a11.89,11.89,0,0,0-14.7,5.12l-326.9,562.35a993.3,993.3,0,0,0,511.15,103.66c529.72-34,945.69-477.12,991.86-1010.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M737.44,2529.85,1054,1962.15a9.58,9.58,0,0,0-2.23-12c-97.44-82.06-175.35-192.09-175.35-334.76,0-35.19-15.6-86.41-8.45-119.42L272.69,1283.12a1157.17,1157.17,0,0,0-50.88,340.41c0,383.17,203.59,720.17,483.14,913.89A22.52,22.52,0,0,0,737.44,2529.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M705.8,2513.72l328-560.68a17.24,17.24,0,0,0-3.46-21.65c-94.09-82.76-154-207.15-154-347.51a484,484,0,0,1,11-102.51L281.6,1255a8.91,8.91,0,0,0-11.67,5.77A1157.71,1157.71,0,0,0,221.81,1592C221.81,1984.51,415.74,2322.49,705.8,2513.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1373.83,1157.57c187.75,31.4,333.34,189.49,358,387a21.6,21.6,0,0,0,20.68,19l908.07,30.43c2.82-2.74,4.31-4.18,7.14-6.91C2665,827.48,2120.24,176.66,1390.6,90.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1905.76,
    cy: 573.63,
    r: 219.76,
    transform: "translate(152.57 1515.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1903.68,
    cy: 574.27,
    r: 199.87,
    transform: "translate(151.5 1514.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1794.73,770.51c3.15-14.62,5.64-24.19,5.64-24.19l-55.56-94.09s-18,18.21-28.76,97.51a18.3,18.3,0,0,0,18.13,20.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2095.22,749.43c-15.43-68.76-42.89-100.77-42.89-100.77l-34.77,115.19s1,2.27,2.66,6.66h58.13A17.29,17.29,0,0,0,2095.22,749.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1794.3,770.51c57.12,21,134.72,18.07,225.28,0a298.71,298.71,0,0,1,8.85-29.07l23.9-92.81c-33.49-30-80.57-39.94-98.68-42.76-42.09-10.44-91.28-1.19-91.28-1.19-66.7,4.66-117.56,47.46-117.56,47.46l41.33,94.05A190.25,190.25,0,0,1,1794.3,770.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1870.91,559.34l-1.42,46.88a10.63,10.63,0,0,0,7.11,10.35c12,4.23,36.79,10.66,60.31,2.24a10.6,10.6,0,0,0,6.86-11.54l-7-47.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1853.55,480.63s2.75,63.33,13.77,88.11,38.54,24.79,41.3,24.79,27.53-5.51,41.3-27.54,19.27-93.62,19.27-93.62-24.78-27.53-57.82-30.28S1853.55,466.87,1853.55,480.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1957.17,503.49s12.64-18.95,19-12.63-6.32,47.38-19,47.38S1957.17,503.49,1957.17,503.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1862.41,506.65s-15.8-22.11-22.12-15.79,9.48,47.38,22.12,47.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1977,465.13c.07-4.29-.17-8.72-.39-13.77a101.89,101.89,0,0,1,.79-15.11c1.55-14.48-13.55-25.94-27.23-22.31a5.24,5.24,0,0,1-3.21.24c-1.26-.49-1.82-1.94-2.33-3.2-3.16-7.88-11.57-18.07-19.53-21.4a43.8,43.8,0,0,0-21.78-3.22,44.5,44.5,0,0,0-34.74,25.24,4.46,4.46,0,0,1-1.43,2,4.17,4.17,0,0,1-2.22.44c-7.45.1-16-1.53-22.33,3.05-5.34,3.89-9.24,9.94-9.62,16.63-.41,7.31,2.73,14.31,6,20.87,2,4,4,8.53,2.45,12.67a38.9,38.9,0,0,1-1.89,3.62c-6.79,13.46,11,26.72,14.33,38.8q3.73,13.74,7.49,27.5a66,66,0,0,0,.93-17.8c-.68-8.18-2.89-16.25-2.6-24.45a40,40,0,0,1,4.29-17c2.61-5.05,7.37-7.28,10.93-11.71,3.3,3.07,6.88,6.29,11.34,6.94a19,19,0,0,0,8.35-1.11c4.09-1.28,9.89-5.9,13.87-6.21s5.34,3.85,8,6.05c7.28,6.11,19.68,7.8,28.4,4.15-2,.85,9.8,22.89,10.18,24.89a237.39,237.39,0,0,1,4.06,35.57c.94.69,2-.72,2.31-1.84,2.15-8,2.81-16.22,4.2-24.34,1.57-9.18,5.28-17.82,8.27-26.59A58.41,58.41,0,0,0,1977,465.13Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2341.44,
    cy: 462.62,
    r: 201.37,
    transform: "translate(358.67 1791.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2339.53,
    cy: 463.22,
    r: 183.15
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2300.26,423.43c-11.6,0-23.63,1.48-28.17-12.49-8.54-26.3,5.81-65.63,29.36-79.95,7.87-4.79,17.05-6.88,26.09-8.7,10.62-2.13,19.81-2.66,29.39,2.49,8.84,4.76,17.42-2.88,26.59,3.22,7.79,5.19,13.76,13.36,17.92,21.61,5.44,10.78,8.26,22.67,10.63,34.51.54,2.68,1,5.46.45,8.13a19.71,19.71,0,0,1-3,6.15c-9.51,14.72-22.16,25-40.45,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2297.93,377.13s2.1,4.39-11.56,11.25c-7.61,3.83-22.42,9.49-24.38,26-1,8.53-4.34,29.59-12.45,30.89-20.21,3.24-47.49,15.85-50,40.37-2.92,28.14,5.18,42.92,19.5,46.6,10.53,2.7,13.19,5.53,11.06,16.65-2,10.67,6,49,23.71,58.7,39.56,21.85,74-77.72,74-77.72l8.1-128.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2388.46,365.89s-2.14,4.65,11.76,11.92c7.76,4.06,22.83,10.05,24.82,27.55,1,9,3.44,21.73,11.7,23.11,20.57,3.43,44.41,23.48,49.48,62.39,3.87,29.71-4.58,61.56-19.16,65.46-10.72,2.87-9.91-2.81-7.74,9,2.07,11.3-2.8,6.94-20.77,17.27-40.28,23.16-80.5-54.85-80.5-54.85l-8.24-136.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2334.62,508.63s30.57-7.87,37.07,1.87c3.24,16.19,4.91,32.28,4.91,32.28l-35.22,6.61-23.3-5.36-5.54-3.22-2.3-22.94S2322.15,511,2334.62,508.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2298,426.93s-4.92-14.75-12.29-9.83,11.07,36.28,11.07,36.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2371.69,426.93s0-22.12,12.28-9.83-12.28,29.49-12.28,29.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2487.44,627.81c-10.29-49.67-25.06-88.49-29.73-90.73l-27.9,69a181.43,181.43,0,0,0-5.18,46.11h42.91A20.31,20.31,0,0,0,2487.44,627.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2272.65,652.22c1.28-22.19.72-36.16.72-36.16l-39.32-63.84s-4.92,19.57-9.83,71.18q-.34,3.6-.66,7.32a19.86,19.86,0,0,0,19.8,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2327.09,652.36h42.81l11.62-122.06s-9.83-2.53-14.75-19.73-7.37-51.65-7.37-51.65l-44.24,9.81s4.91,46.84-4.92,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2393,652.36l6.17-77.05c-44.86,26.84-91,25.54-137.76,11.31l13.28,65.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2337.59,652.22C2324.3,588.11,2310.24,518,2310.24,518l-7.37,14.7-68.82,19.73c3.37,15.72,13.65,59,24,99.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2435.93,652.22c3.67-19.64,6.9-35,6.9-35l14.88-80.17c-4.68-4.69-78.16-14.76-78.16-14.76l-7.86-11.74s-9.82,71.32-18.2,141.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2293,392.52s-2.45,59,4.92,68.82,17.21,32,34.41,34.41,44.24-46.7,44.24-49.16-2.46-66.36-2.46-66.36S2322.53,338.45,2293,392.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2283.2,382.69s-9.83,29.49,19.67,19.66l29.49-9.83s29.49-17.21,34.41-9.83,9.83,25.53,9.83,25.53,9.83-25.53,0-40.28S2305.32,340.91,2283.2,382.69Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1996.82,
    cy: 1063.11,
    r: 227.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1994.66,
    cy: 1063.79,
    r: 206.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 2000.37,
    cy: 974.57,
    r: 67.5,
    transform: "translate(-103.23 1699.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1935.54,955.72c-29.69,102.66-49.87,196-46.59,222.23l86.55-9.13,10-189.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2031.35,945.12l-11.87,232.12,97.93,52.15c-2-79.32-42.58-283.16-59.17-288.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "2031.38 1070.83 2034.22 1134.05 1972.91 1143.28 1969.05 1076.91 2031.38 1070.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2060.46,1032.76s-14.7,65.63-54.46,73.51-51.54-54-53.64-58.39c0,0-8.89,4.19-10.88-4.65s-12.49-31.07,7.29-30.62c0,0-3.89-22.08,3-32.91s20.64-36.91,49.06-29.67S2074.63,981.2,2060.46,1032.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2033.27,1112.91l38.89,20.62-50.93,55.88-94.14-59.22c14.34-5.35,28.44-12.55,41.32-14.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1951,953.9c-13.29,18.59-2.84,35.07-6.41,48.42,12.87-4.68,56.34-11.68,69.42-10.39,2.7-8.89-2.61-23.68-5.33-35.34,4.25,11.07,14,28,12.92,36.76,17.57.81,14,1.06,33.71,9l-15.37-53.61C2005.71,932.72,1976.14,934.76,1951,953.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2016.43,890.9c0,12.89-12.12,27.35-20.87,27.35-7.2,0-20.87-14.46-20.87-27.35s9.35-23.34,20.87-23.34S2016.43,878,2016.43,890.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2100.06,1273.43l21.41-119.08c-29.13-19.81-56.12-29.24-88.2-41.4-9.94,20.68-55.36,18.63-64.86,2.57-30.2,7.67-59,21.85-86.76,40.22l29.3,117.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2158.78,1252.37c-17.34-74.14-37.31-98-37.31-98l-32,97.47s3.85,7.78,8.92,21.61h43.69A17.17,17.17,0,0,0,2158.78,1252.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1913.07,1273.43a283.7,283.7,0,0,1,14.42-39.78l-45.84-77.88s-22.6,39.27-30.09,98.41a17.14,17.14,0,0,0,17,19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2037.93,949.91c22.71,57.42,34,219.37,20.18,305,21.71-74.77,48.76-169.61,7.43-297.14Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2473.27,
    cy: 893.57,
    r: 204.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2471.33,
    cy: 894.18,
    r: 186.17,
    transform: "translate(91.56 2009.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2596.35,1100.88a18.7,18.7,0,0,0,18.7-18.83c-.19-29.73-.8-55.84-2.18-70.26-3.54-36.8-23.07-48.47-23.07-48.47l-10,137.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2548.31,1100.88c-1.45-77.06-2.88-140.79-2.88-140.79-34.89-21.47-163.73-18.78-163.73-18.78s-8.95,74.34-19.15,159.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2335.53,1100.88h119.91c-3.86-37.25-34.82-175.08-34.82-175.08l-96.17,29.43S2332,1041.16,2332,1068C2332,1074.15,2333.77,1086.08,2335.53,1100.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2339.14,1100.88c.43-45.42-.38-129.19-14.69-145.55,0,0-18.53,9.54-37.32,71.28-5.42,17.81-10.35,34.73-14.93,50.84a18.39,18.39,0,0,0,17.7,23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2586.19,1100.88c3.46-65.32,6.48-134.93,3.61-137.8-5.37-5.37-69.87-26.42-69.87-26.42s-42,128.5-51.78,164.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2424.65,948.59l16.1-56.37h59.05l8.06,64.42S2456.86,970.06,2424.65,948.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2424.65,819s5.55,53.93,14.9,75,32.76,21.06,35.1,21.06,23.39-4.68,35.09-23.4,16.38-79.54,16.38-79.54-21.06-23.4-49.13-25.74S2424.65,807.31,2424.65,819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2515.91,838.54s10.74-16.11,16.1-10.74-5.36,40.27-16.1,40.27S2515.91,838.54,2515.91,838.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M2435.38,841.22s-13.42-18.79-18.79-13.42,8.06,40.27,18.79,40.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M2543.46,806.59a50,50,0,0,0,2.65-23.51c-1.39-11.92-7.79-34-16.66-42.89,2.52,2.52-21.54,12.7-25.25,12.34,7.23-5.9,16.23-12.64,16.56-22.92-8.37,5.64-18.59,7.69-28.53,9.44-24.8,4.37-51.45,3.45-70.53,22.22-8,7.84-13.38,20-11.33,31.25,1.49,8.26,13.78,17,6.22,24.55-5.35,5.37,10.85,15.14,13.48,30.38a26.71,26.71,0,0,0,.7,3.27c-.23-7.79-3.23-16.16-3-23.74.39-15.54,23.82-16.63,35.28-17.66,15.25-1.37,31.88-1.24,45.08-10.15,5.36-3.62,8.77,25.66,9,27.1,1.33,8.33,2.91,17.27,1.5,25.69h3.7c1.07-9.88.09-19.33,7.35-26.52a74,74,0,0,0,9.79-11.07A39.06,39.06,0,0,0,2543.46,806.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2437.89,902.25c-2,12.34-2.68,18.3-6.61,30.18-3.54,10.72-.93,25.66-.72,36.93.3,15.74,12.53,32.95,9.85,48.42-6.85-19.24-27.75-34.21-38.45-52.18-10.46-17.55-17.92-31.72-6-48.28C2403.4,907,2438.05,901.29,2437.89,902.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2501.1,953.85c1.48,32.77-4.94,39.43-10.15,72.54,7-22.38,22.76-34.13,35.17-54.08,12.23-19.66,16.19-44.17-3.83-57.27-1.37-.9-20.74-9.87-20.65-8.13C2501.88,911.7,2500.46,939.65,2501.1,953.85Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 624.88,
    cy: 1038.9,
    r: 140.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 624.88,
    cy: 1038.9,
    r: 135.7,
    transform: "translate(-551.59 746.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M499.79,1033.53h-.07a1.28,1.28,0,0,1-1.21-1.35,126.09,126.09,0,0,1,1.83-15.89,1.29,1.29,0,0,1,1.5-1,1.27,1.27,0,0,1,1,1.49,126.8,126.8,0,0,0-1.8,15.58A1.28,1.28,0,0,1,499.79,1033.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M513,983.81a1.17,1.17,0,0,1-.57-.14,1.27,1.27,0,0,1-.57-1.72,126,126,0,0,1,113-69.6,128,128,0,0,1,22.83,2,1.29,1.29,0,0,1-.46,2.53,124.74,124.74,0,0,0-22.37-2A123.46,123.46,0,0,0,514.13,983.1,1.28,1.28,0,0,1,513,983.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 627.84,
    cy: 1041.85,
    r: 114.85,
    transform: "translate(-552.81 749.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M663,998.45c0,19.45-15.76,40.45-35.21,40.45s-35.21-21-35.21-40.45,15.76-33.24,35.21-33.24S663,979,663,998.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M584.09,1113.77h86a20.81,20.81,0,0,0,19.82-14.47l4.62-14.45A20.79,20.79,0,0,0,681.94,1059c-35-12.79-71.16-11.15-108.22,1.18a20.72,20.72,0,0,0-13.27,25.12l3.56,13.13A20.8,20.8,0,0,0,584.09,1113.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 878.14,
    cy: 820.81,
    r: 140.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 878.14,
    cy: 820.81,
    r: 135.7,
    transform: "translate(-323.2 861.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M753.05,815.45H753a1.28,1.28,0,0,1-1.22-1.35,128,128,0,0,1,1.84-15.89,1.28,1.28,0,0,1,2.53.45,124.89,124.89,0,0,0-1.8,15.58A1.3,1.3,0,0,1,753.05,815.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M766.24,765.72a1.21,1.21,0,0,1-.58-.14,1.28,1.28,0,0,1-.57-1.72,126,126,0,0,1,113-69.6,128.12,128.12,0,0,1,22.83,2,1.29,1.29,0,0,1-.46,2.53,124.74,124.74,0,0,0-22.37-2A123.47,123.47,0,0,0,767.39,765,1.3,1.3,0,0,1,766.24,765.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 881.09,
    cy: 823.76,
    r: 114.85,
    transform: "translate(-324.42 864.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M916.26,780.37c0,19.44-15.77,40.44-35.22,40.44s-35.21-21-35.21-40.44S861.6,747.12,881,747.12,916.26,760.92,916.26,780.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M837.35,895.68h86a20.8,20.8,0,0,0,19.81-14.46l4.63-14.46a20.77,20.77,0,0,0-12.56-25.86c-35-12.8-71.15-11.15-108.21,1.18a20.71,20.71,0,0,0-13.28,25.11l3.56,13.13A20.81,20.81,0,0,0,837.35,895.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 929.91,
    cy: 1145.42,
    r: 140.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 929.91,
    cy: 1145.42,
    r: 135.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M804.82,1140.06h-.07a1.29,1.29,0,0,1-1.22-1.35,127.92,127.92,0,0,1,1.84-15.9,1.29,1.29,0,1,1,2.53.46,124.51,124.51,0,0,0-1.8,15.57A1.28,1.28,0,0,1,804.82,1140.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M818,1090.34a1.37,1.37,0,0,1-.58-.14,1.29,1.29,0,0,1-.56-1.73,126,126,0,0,1,113-69.6,128,128,0,0,1,22.83,2,1.28,1.28,0,0,1,1,1.5,1.26,1.26,0,0,1-1.49,1,125.67,125.67,0,0,0-22.37-2,123.47,123.47,0,0,0-110.75,68.19A1.29,1.29,0,0,1,818,1090.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 932.87,
    cy: 1148.38,
    r: 114.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M968,1105c0,19.45-15.77,40.44-35.21,40.44s-35.22-21-35.22-40.44,15.77-33.25,35.22-33.25S968,1085.53,968,1105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M889.12,1220.3h86a20.81,20.81,0,0,0,19.82-14.47l4.62-14.46A20.78,20.78,0,0,0,987,1165.51c-35-12.79-71.15-11.15-108.21,1.18a20.73,20.73,0,0,0-13.28,25.12l3.57,13.13A20.81,20.81,0,0,0,889.12,1220.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1161.43,1139.84s-38.78,18.87-45.91,40.53c-5.72,17.39-48.6,19.63-52.83,53.82-2.19,17.66-15.25,31.8-32.84,34.49-43.79,6.71-111.28,29.46-122.08,105.49-8.24,58,21.35,80,52.4,87.66,22.8,5.6,38,27.78,33.34,50.8-4.42,22.09,2.18,47.62,40.44,67.8,85.73,45.24,171.35-107.17,171.35-107.17l17.55-266.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1627.94,1076.75s-171.18,270.76-374.74,323.06c0,0,39.67,113,70.28,125.9,0,0,250.43-209,314.78-410.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M809,2808.53l-5.55,45.61A18.83,18.83,0,0,1,787,2870.62c-14.62,1.67-38.09,3.38-61,1a16.14,16.14,0,0,1-13.55-20.93c5.59-17.61,15.83-44,30.59-59.59h50.6A15.59,15.59,0,0,1,809,2808.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1205.3,2274.25l8.54,50.24s-28.6,289.66-33.69,405.53a90.89,90.89,0,0,0,13.44,51.6l49.73,80.75-126.38-74.58-2.52-15.42,20.69-28.44-27.1-324.5a99.62,99.62,0,0,1,11.33-55.06l26.14-49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1251.64,2874.07h-40.33a24.28,24.28,0,0,1-19.27-9.45c-12.57-16.34-38.62-48.21-51.08-49-16.77-1.12-14.62,58.49-14.62,58.49h-9.4L1105,2800a43.84,43.84,0,0,1,23-45.83s3.84,28.35,24.62,40.89,84.57,57.44,84.57,57.44a57.48,57.48,0,0,1,16.39.43C1266.35,2855.22,1264.57,2874.07,1251.64,2874.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1032.2,2298.11S864.67,2615.9,838,2688.46s-36,133.08-36.31,138.81c-.56,9-11.7,17.55-42.41,17.55-15.84,0-23.61-6.35-27.41-12.5a17.89,17.89,0,0,1-.67-17.34c9.69-19.61,40.44-82.29,51.83-110.71,13.6-33.94,42.85-187.75,58.89-241.23s34.18-111.49,104-164.93C946,2298.11,994,2251.14,1032.2,2298.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1138,1777.4c43.21-183.12-66.27-286.69-66.27-286.69,69.08-66.31,194.94-96.48,194.94-96.48s120.1,87.8,105.85,156.53c-8.35,40.28-84.41,241.26-84.41,241.26S1217.81,1825.31,1138,1777.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1042.22,1868.06c17.59-53,95.82-90.66,95.82-90.66,79.77,47.91,150.11,14.62,150.11,14.62s15.77,60.3,4.88,116.33-79.19,416.14-79.19,416.14c-107.63,21.81-273.16-21.94-273.16-21.94C1009.24,2180.83,1024.64,1921,1042.22,1868.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1188.2,1273.22,1153.06,1431c-3.36,13.9,9.31,11.62,23.37,9,23-4.34,52.68-13.27,62.59-31.18a16.85,16.85,0,0,0,1.8-5.95l15.1-109.43a19.69,19.69,0,0,0-11.51-20.67l-29.13-12.91A19.66,19.66,0,0,0,1188.2,1273.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1255.5,1129.35s37.4,25.32,53.47,89.8-10,87.61-36.82,86.2-65.59-9.7-99.23-56S1206.48,1098.41,1255.5,1129.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1206.84,1223.38s-13.71-92.39,63-78.26l15.51,16.15s37.55-42.29-4-74.25-99.21-23.78-131.11,34.41-43.48,99.08-16.74,135.24,46.85,5.15,46.85,5.15-12.26-31.3-2.09-44.73,23.3,7.81,23.3,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1196.36,1231.29s-6.77-47.53-31-33.94,8.75,44.4,22,54.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1626.76,1132.5c.52,5.58-20.25,9.44-26.86-14.37,1.82-10.34,5-55.61,13-62.64,42.21-37.46,117.49-79.59,117.49-79.59,8.42,12.85-2.62,21.32-2.62,21.32l-37.58,25.36c3.92,13,9.64,24.46,10.29,39.28a44,44,0,0,1-11.11,30.73c-7.47,8.54-17.54,19.57-26.62,28C1645.55,1136.39,1626.76,1132.5,1626.76,1132.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1647.17,1114l-5.74-2.36c.76-1.86,18.8-45.68,27.52-54.79,3.31-3.46,4.91-6.42,4.76-8.81a6.23,6.23,0,0,0-1.93-3.87l-30.4,16.26-13.43,21-5.23-3.35,14.3-22.4,35.61-19,1.61,1.31c3.6,3,5.46,6.11,5.68,9.68.26,4.25-1.86,8.66-6.48,13.49C1666.87,1068.05,1652.25,1101.67,1647.17,1114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1177.19,1874c.24,0,.48,0,.73,0l313.88-.33a13.91,13.91,0,1,0,0-27.81l-313.89.34a13.9,13.9,0,0,0-.69,27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1774,1592H1512.56a49.87,49.87,0,0,0-45.06,28.27l-120.84,253.54h324.85a30.26,30.26,0,0,0,28.16-18.95l93.72-234.61A20.69,20.69,0,0,0,1774,1592Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1609.41,
    cy: 1728.27,
    rx: 33.16,
    ry: 20.57,
    transform: "translate(-535.8 2715.79) rotate(-71.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1071.32,1491.09c-42.82,43.22-97.16,234.78-70.2,266.77,23.74,37.25,104.56,88,181.52,88H1296.2c-47.72-50.7-80.57-63.56-119.7-28.1-31-13.27-71.31-64.66-98.18-87.61a28.66,28.66,0,0,1-6-36.32c21.35-36.14,48.12-73.29,56.64-109.28C1130.79,1542.4,1099.59,1494.13,1071.32,1491.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1636.07,2887.05a11.25,11.25,0,0,1-7.87-3.88c-29.11-33.64-242.3-298-5.64-572.1,224.67-260.2,331-318.16,335-461.41.46-16.73,22.6-22.4,31.11-8,63.59,107.7,169.19,362.23-102.45,554.93-299.66,212.56-258.36,417.78-238.75,475.5a11.3,11.3,0,0,1-11.38,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1675.39,2889.42a16.26,16.26,0,0,1-14.92-12.55c-11.14-47.92-43.16-227.71,86.7-285.79,142.95-63.93,271.86,64,371.81-51.24a8.22,8.22,0,0,1,14.42,6.12c-5.41,56.67-38.48,189.48-227,229.88-201.81,43.24-223,68.36-216.69,97.06a13.72,13.72,0,0,1-14.3,16.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1961.33,1995.13a209.76,209.76,0,0,1-7.48,31,306.68,306.68,0,0,1-11.06,29.73,377.33,377.33,0,0,1-29.87,56c-23,35.7-51.63,67.7-83.77,95.42a580.48,580.48,0,0,1-50.46,38.38,482.49,482.49,0,0,0-47.83,37.52A532.6,532.6,0,0,0,1650,2374c-46.68,66.36-77.48,144.53-83.45,225.73a426,426,0,0,0,8.45,121.52c8.5,40,23,78.77,41.07,115.81a4,4,0,0,1-7,3.73,477.28,477.28,0,0,1-47.38-116.39,415.39,415.39,0,0,1-13.05-125.78c2-42.4,10.71-84.45,24.86-124.48s34.1-78,58-113a531.21,531.21,0,0,1,83.89-95.33,505.61,505.61,0,0,1,50-39.5,581.71,581.71,0,0,0,49-36.52c31.15-26,59.53-55.41,83.36-88.35a427.27,427.27,0,0,0,32.53-51.63c9.45-18,18.13-36.84,24-56.1l.07-.25a3.64,3.64,0,0,1,7.08,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1664.45,2857.18a12.82,12.82,0,0,0,0-5.09l-.53-5-.86-10q-.73-10-1.06-20c-.41-13.34-.27-26.71.51-40.07,1.65-26.67,5.65-53.44,14.44-79,8.69-25.41,22.88-50.14,44.88-67.26a109.8,109.8,0,0,1,36.86-18.5,139.53,139.53,0,0,1,40.71-5.15c53.54,2.17,106.33,8.43,159.12,12.77,26.27,1.92,52.88,3.4,78.13-2a116.07,116.07,0,0,0,18.33-5.66,98.31,98.31,0,0,0,16.83-9.09c10.62-7.17,19.72-16.56,27.71-26.82l0,0a3.24,3.24,0,0,1,5.16,3.93c-8.07,10.83-17.45,21-28.72,29a105.58,105.58,0,0,1-18,10.19,123.51,123.51,0,0,1-19.55,6.51c-26.87,6-54.06,4.67-80.61,3s-53-4.7-79.46-7-53-4.4-79.16-5.49a130.65,130.65,0,0,0-38.1,4.45,101.12,101.12,0,0,0-34.08,16.73c-20.52,15.34-34.51,38.35-43.35,62.79s-13.4,50.77-15.5,77c-1,13.15-1.39,26.36-1.23,39.57.08,6.61.32,13.21.68,19.81l.68,9.88.43,4.93a10.83,10.83,0,0,0,1.14,4.81,3,3,0,1,1-5.47.8Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionSupport1);
export default __webpack_public_path__ + "static/media/production_support_1.e2e7c3dfb104bd2a86461a3762040d89.svg";
export { ForwardRef as ReactComponent };